import React,{useState} from "react";
import {Link as RLink} from "react-router-dom";
import {Menu,MenuItem, ListItemIcon, Divider,Avatar,Icon} from '@mui/material';

export interface TypeItem{
    id?:string,
    title:string,
    to?:string,
    icon:string,
    avatar?:boolean,
    sep:boolean
}

const DropdownMenu:React.FC<any> = (props:any)=>{
    
    return (
        <>
            <Menu
                anchorEl={props.menuEl}
                open={props.menuOpen}
                onClose={props.onClose}
                onClick={props.onClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }} 
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {props.menuList && props.menuList.map((item:any,index:number)=>(
                    <CItem key={index} item={item} onItemClick={()=>{props.onItemClick(item)}}/>
                ))}
        </Menu>
        </>
    );
}

const CItem = (props:any)=>{
    if(props.item.to){
        return (
            <>
            <MenuItem component={RLink} to={props.item.to}>
                <MenuContent item={props.item}/>
            </MenuItem>
            {props.item.sep?<Divider/>:''}
            </>
        )
    }else{
        return(
            <>
            <MenuItem onClick={props.onItemClick}>
                <MenuContent item={props.item}/>
            </MenuItem>
            {props.item.sep?<Divider/>:''}
            </>
        )
    }
}


const MenuContent = ({item})=>{
    return (
        <>
            {item.icon?<ListItemIcon><Icon>{item.icon}</Icon></ListItemIcon>:''}
            {item.avatar?<Avatar />:''}
            {item.title}
        </>
    )
}

export default DropdownMenu;